// extracted by mini-css-extract-plugin
export default {"root":"Profile_root__3EWUt","avatar":"Profile_avatar__wukFa","name":"Profile_name__yLmXX"};